export const sidebarData = [
    {
      title: "Tasks",
      path: "/worker/home",
      icon: "📝",
      cName: "nav-text",
    },
    {
      title: "Your Profile",
      path: "/worker/profile",
      icon: "🧔🏻",
      cName: "nav-text",
    },
  ];
  